module.exports = __webpack_public_path__ + "img/Imposte fixe vitré.a5fbe691.jpg";